<template>
  <!-- 热血盲盒管理-房间数据 -->
  <div class="battle_user_data-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="query.user_id"
            placeholder="请输入用户UID"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.rid" placeholder="请输入房间ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.code"
            placeholder="请输入房间编号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.status"
            @change="getData(1)"
            placeholder="请选择房间状态"
          >
            <el-option :value="undefined">全部</el-option>
            <el-option :value="-1" label="已取消"></el-option>
            <el-option :value="0" label="等待中"></el-option>
            <el-option :value="1" label="进行中"></el-option>
            <el-option :value="2" label="已结束"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="对战开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="对战结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="rid" label="房间id" align="center">
        </el-table-column>
        <el-table-column prop="status" label="房间状态" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.status == -1">已取消</span>
            <span v-if="row.status == 0">等待中</span>
            <span v-if="row.status == 1">进行中</span>
            <span v-if="row.status == 2">已结束</span>
          </template>
        </el-table-column>
        <el-table-column prop="user_arr" label="参与用户" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.user_arr }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="winUser" label="胜利者" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.winUser">{{ row.winUser }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="房间金额" align="center">
        </el-table-column>
        <el-table-column prop="nums" label="人数" align="center">
        </el-table-column>
        <el-table-column label="盲盒开箱金额" align="center">
          <template slot-scope="{ row }">
            <span>{{ (row.price * row.nums).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="prizePrice" label="盲盒奖品金额" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.prizePrice">{{ row.prizePrice }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="startTime" label="开始时间" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.startTime">{{ row.startTime }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="结束时间" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.updateTime && row.status == 2">{{
              row.updateTime
            }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="取消时间" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.updateTime && row.status == -1">{{
              row.updateTime
            }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="200px"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" @click="openDetailsDialog(row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 底部分页条 -->
      <el-pagination
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
        :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1"
        :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <RoomDetailsDialog
      v-model="dialogInfos"
      :visible="detailsVisible"
      @close="detailsVisible = false"
    ></RoomDetailsDialog>
  </div>
</template>           

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import RoomDetailsDialog from '@/components/battle/RoomDetailsDialog.vue'

export default {
  name: 'battle_user_data',
  components: {
    RoomDetailsDialog
  },
  data() {
    return {
      detailsVisible: false,//详情弹窗显示标志
      loading: false,//加载动画
      query: {
        page: 1,
        user_id: '',
        code: '',
        rid: '',
        status: undefined,
        start_time: '',
        end_time: ''
      },
      dialogInfos: undefined,
      dataList: [], //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('battle_room_data', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openDetailsDialog(rowInfo) {
      // 打开详情弹窗
      this.detailsVisible = true
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
.battle_user_data-box {
  header {
  }

  .body-box {
  }
}
</style>